module.exports = __webpack_public_path__ + "static/img/ind_ban_01.84c469ec.jpeg";